import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Typography } from '@mui/material';

import { useI18n } from '@braincube/i18n';

import ButtonsGroupWithHelp from 'components/ButtonsGroupWithHelp';
import { MainSection, MainSectionTitle, MainSectionContent } from 'components/MainSection';

function MandatoryTwoFactorAuth() {
    const i18n = useI18n();
    const navigate = useNavigate();

    const handleClick = useCallback(() => {
        navigate('/');
    }, [navigate]);

    return (
        <MainSection>
            <MainSectionTitle>{i18n.t('certify.mandatoryTwoFactorAuth.title')}</MainSectionTitle>
            <MainSectionContent>
                <Typography variant="body2">{i18n.tc('certify.mandatoryTwoFactorAuth.text')}</Typography>
                <ButtonsGroupWithHelp onBigButtonClick={handleClick} label={i18n.tc('app.backButton')} />
            </MainSectionContent>
        </MainSection>
    );
}

export default MandatoryTwoFactorAuth;
